var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrievance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3657_135165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 4.06799C12.8666 4.15266 13.4499 4.34533 13.8853 4.78133C14.6666 5.56199 14.6666 6.81933 14.6666 9.33333C14.6666 11.8473 14.6666 13.1047 13.8853 13.8853C13.1039 14.666 11.8473 14.6667 9.33325 14.6667H6.66659C4.15259 14.6667 2.89525 14.6667 2.11459 13.8853C1.33392 13.104 1.33325 11.848 1.33325 9.33333C1.33325 6.81866 1.33325 5.56199 2.11459 4.78133C2.54992 4.34533 3.13325 4.15266 3.99992 4.06799",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95933 7.46666L5.43933 7.86666C6.664 8.88733 7.276 9.39666 8 9.39666C8.72387 9.39666 9.33644 8.88618 10.56 7.86656L10.5607 7.86599L11.0407 7.466L11.0459 7.46165C11.5137 7.07188 11.7485 6.87633 11.874 6.608C12 6.33866 12 6.03133 12 5.41801V5.41799V4.66666V4.66025C12 3.09319 12 2.30866 11.512 1.82133C11.0233 1.33333 10.238 1.33333 8.66667 1.33333H7.33333C5.762 1.33333 4.976 1.33333 4.488 1.82133C4 2.30933 4 3.09533 4 4.66666V5.41733C4 6.032 4 6.33866 4.126 6.608C4.25179 6.8762 4.4872 7.07266 4.95693 7.46465L4.95933 7.46666Z",
    stroke: "#333333",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.13043L8 5.43443",
    stroke: "#333333",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 7.40416C8.33127 7.40416 8.5999 7.13553 8.5999 6.80416C8.5999 6.47279 8.33127 6.20416 7.9999 6.20416C7.66853 6.20416 7.3999 6.47279 7.3999 6.80416C7.3999 7.13553 7.66853 7.40416 7.9999 7.40416Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3657_135165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrievance);
export default __webpack_public_path__ + "static/media/grievance.036f8f849220d7a55d36a48f59e1a37f.svg";
export { ForwardRef as ReactComponent };